export const AUTO_LOGOUT_OPTIONS = {
  FIVE: { value: 'FIVE', minutes: 5 },
  TEN: { value: 'TEN', minutes: 10 },
  FIFTEEN: { value: 'FIFTEEN', minutes: 15 },
  THIRTY: { value: 'THIRTY', minutes: 30 },
  SIXTY: { value: 'SIXTY', minutes: 60 },
}

export const AUTO_LOGOUT_OPTIONS_LIST = Object.values(AUTO_LOGOUT_OPTIONS)

export const getMinutesFromValue = (value) => {
  const option = AUTO_LOGOUT_OPTIONS_LIST.find((opt) => opt.value === value)
  return option ? option.minutes : AUTO_LOGOUT_OPTIONS.FIVE.minutes // Default to 5 minutes
}

export const getValueFromMinutes = (minutes) => {
  const option = AUTO_LOGOUT_OPTIONS_LIST.find((opt) => opt.minutes === minutes)
  return option ? option.value : 'FIVE'
}
